const defaultStore = {
  editingTagObj: null,
  isShowTagPopup: false,
  isCreatingTagModalMode: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case 'CONFIRM_EDITING_TAG':
      return {
        ...state,
        editingTagObj: action.payload.editingTagObj,
        isShowTagPopup: true,
        isCreatingTagModalMode: false,
      };

    case 'CANCEL_EDITING_TAG':
      return {
        ...state,
        editingTagObj: null,
        isShowTagPopup: false,
        isCreatingTagModalMode: false,
      };

    case 'TAG_EDIT_SUCCESS':
      return {
        ...state,
        isShowTagPopup: false,
      };

    case 'CONFIRM_CREATING_TAG':
      return {
        ...state,
        editingTagObj: null,
        isShowTagPopup: true,
        isCreatingTagModalMode: true,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tagEdit.js